/**
 * UTF-8 byte length without Node's Buffer — safe for browser bundles and Node tests.
 */
export function utf8ByteLength(value: string): number {
  const text = String(value ?? "");
  if (typeof TextEncoder !== "undefined") {
    return new TextEncoder().encode(text).length;
  }
  if (typeof Blob !== "undefined") {
    return new Blob([text]).size;
  }
  // Fallback: over-estimate for ASCII-heavy JSON (not used in modern runtimes).
  return text.length;
}

export function utf8JsonByteSize(value: unknown): number {
  try {
    return utf8ByteLength(JSON.stringify(value));
  } catch {
    return Number.MAX_SAFE_INTEGER;
  }
}
